/**
 * Forecast API functions.
 *
 * Maps to backend forecast-api endpoints:
 *   POST /v1/forecast/short-term  - Day-ahead hourly load/generation forecast
 *   POST /v1/forecast/long-term   - Monthly load/generation forecast (SARIMA)
 *
 * The Vite proxy routes /v1/forecast -> forecast-api:8000.
 */

import client from './client';

export const forecastAPI = {
  /**
   * Generate a short-term (hourly) forecast.
   * @param {Object} data - ShortTermForecastRequest payload
   * @returns {Promise<Object>} ShortTermForecastResponse
   */
  shortTerm: (data) => client.post('/v1/forecast/short-term', data),

  /**
   * Generate a long-term (monthly) forecast using SARIMA.
   * @param {Object} data - LongTermForecastRequest payload
   * @returns {Promise<Object>} LongTermForecastResponse
   */
  longTerm: (data) => client.post('/v1/forecast/long-term', data),

  /**
   * Validate forecast against actual measured data.
   * @param {Object} data - Validation payload (forecast + actuals)
   * @returns {Promise<Object>} Validation metrics (MAPE, MAE, RMSE, etc.)
   */
  validate: (data) => client.post('/v1/forecast/validate', data),
};
